import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ExternalPackagingStockMovementHistoryService extends Service {
	constructor(injector: Injector) {
		super("ExternalPackagingStockMovementHistory", injector);
	}

	// API
	getByExternalPackagingId(externalPackagingId: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByExternalPackagingId/${externalPackagingId}`);
	}
}